export default "__VITE_ASSET__DEM1CBD4__"